// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"3d9b3381","657":"b7ec90cb"}[chunkId] + ".chunk.css";
};